// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3sx9Q","colCheckbox":"styles_colCheckbox__OLMF5"};